import React, { useContext, useEffect } from "react";
import NavButton from "../../components/NavButton/index";
import useSocialLogin from "../../hooks/useSocialLogin";
import ContentHeader from "../../components/ContentHeader/index";
import LoaderAnim from "../../components/LoaderAnim/index";
import Divider from "../../components/Divider/index";
import MsmContext, { Actions } from "../../reducers/Context";
import { API, useDataApi } from "../../components/API";
import { getSmartlookData, setStorageData } from "../../utils";

const SignupMethod = () => {
  const { dispatch } = useContext(MsmContext);
  const {
    socialLogin,
    socialData,
    isSocialLoading,
    isSocialError
  } = useSocialLogin();
  const { data, doFetch } = useDataApi();

  useEffect(() => {
    if (data) {
      //console.log("got status", data);
      dispatch({
        type: Actions.GOT_STATUS,
        payload: { far: data.Far }
      });
    } else {
      doFetch(API.GET_STATUS, { ignoreCache: true });
    }
  }, [data]);

  useEffect(() => {
    if (socialData) {
      //console.log("got user", socialData);
      // setStorageData("user", socialData);
      dispatch({
        type: Actions.UPDATED_USER_DETAILS,
        payload: { user: socialData }
      });
      doFetch(
        API.SET_SIGNUP_LEAD,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
          },
          body: `jsonData=${JSON.stringify({
            user: socialData,
            ...getSmartlookData()
          })}`
        },
        { ignoreCache: true }
      );
    }
  }, [socialData]);

  return (
    <>
      <div className="afs-msm-stage-content add-all-padding fx-container-y align-centre justify-centre">
        {isSocialError && <div>Something went wrong ...</div>}

        {isSocialLoading ? (
          <LoaderAnim />
        ) : (
          <>
            <ContentHeader text="How would you like to sign up?" />
            <Divider text="Use a social account" />

            <div className="fx-container-x fx-align-centre fx-justify-around">
              <span className="third-width text-centre">Facebook</span>
              <span className="third-width text-centre">Twitter</span>
              <span className="third-width text-centre">Google</span>
            </div>

            <div className="fx-container-x fx-justify-between afs-msm-social-buttons-container">
              <NavButton
                label="Facebook"
                icon="facebook55"
                iconSize="30"
                iconFill="white"
                colour="#3B5999"
                className="afs-msm-inline-button btn fx-grow"
                onClick={() => {
                  socialLogin("facebook");
                }}
              />
              <NavButton
                icon="twitter1"
                iconSize="30"
                iconFill="white"
                colour="#55ACEE"
                className="afs-msm-inline-button btn fx-grow add-horiz-margin"
                onClick={() => {
                  socialLogin("twitter");
                }}
              />
              <NavButton
                icon="google"
                iconSize="30"
                iconFill="white"
                colour="#D34836"
                className="afs-msm-inline-button btn fx-grow"
                onClick={() => {
                  socialLogin("google");
                }}
              />
            </div>
            <Divider text="Or" />
            <NavButton
              icon="write20"
              iconSize="30"
              iconFill="white"
              iconStroke="black"
              colour="teal"
              className="afs-msm-inline-button btn"
              text="SIGN UP USING EMAIL"
              actionType={Actions.TO_STAGE}
              payload={{ toStage: "email-form" }}
            />
          </>
        )}
      </div>
      <div className="afs-msm-stage-action-buttons">
        <NavButton text="BACK" actionType={Actions.PREV_STAGE} />
      </div>
    </>
  );
};

export default {
  id: "signup-method",
  title: "Sign up to TeamStats",
  subtitles: ["Free to join and use.", "No payment details required."],
  imageUrl:
    "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-3.jpg",
  component: SignupMethod
};
